import React from "react";
import styled from "styled-components";

import {
  Avatar,
  Divider as DefaultDivider,
  Drawer as DefaultDrawer,
} from "@material-ui/core";

import { appPrimaryColor, COLORS } from "constants/colorScheme";
import { SIDEBAR_WIDTH, HEADER_HEIGHT } from "constants/layout";

export const Divider = styled(DefaultDivider)`
  && {
    margin: 16px 0;
  }
`;

export const Image = styled(Avatar)`
  && {
    width: 40px;
    height: 40px;

    margin-right: 16px;

    background-color: ${appPrimaryColor.main};
    border: 2px solid ${COLORS.WHITE};
  }
`;

export const SidebarContent = styled.div`
  display: flex;
  flex-direction: column;

  width: ${SIDEBAR_WIDTH};
  height: 100%;

  overflow-y: auto;
`;

export const SidebarGap = styled.div`
  flex-shrink: 0;

  width: ${SIDEBAR_WIDTH};
  height: auto;
`;

export const TopBar = styled.div`
  position: relative;

  display: flex;
  align-items: center;

  margin: 16px 16px 0px;

  flex-shrink: 0;
`;

export const TopBarContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  width: 100%;
  height: 100%;
`;

export const AdminInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;

  width: 100%;

  && .MuiTypography-root {
    color: ${COLORS.WHITE};
  }
`;

const CustomDrawer = props => (
  <DefaultDrawer {...props} variant="permanent" classes={{ paper: "paper" }} />
);

export const Drawer = styled(CustomDrawer)`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;

  z-index: 99;

  && .paper {
    padding-top: ${HEADER_HEIGHT};

    border: 0;
    background-color: ${COLORS.BACKGROUND_SIDEBAR};
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  flex: 1;

  width: 100%;

  padding: 16px 8px;

  & .MuiListItem-root {
    cursor: pointer;
  }
`;
